import { usePublicLang } from "@/contexts/PublicLangContext";
import { PUBLIC_BOOKING } from "@/constants/testIds";

// Fix E (2026-09-09): indicador de pasos con la identidad de la landing
// (Tiffany para el paso activo, oro suave para los completados), en vez del
// unico color plano anterior. Mismo data-testid, misma prop API.
export default function PublicStepper({ step, total = 4 }) {
  const { t } = usePublicLang();
  return (
    <div className="mb-8 sm:mb-10" data-testid={PUBLIC_BOOKING.stepper}>
      <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#5C554D] mb-2">
        {t("stepper.stepLabel", { current: step, total })}
      </p>
      <div className="flex gap-1.5">
        {Array.from({ length: total }, (_, i) => {
          const segmentStep = i + 1;
          const isDone = segmentStep < step;
          const isActive = segmentStep === step;
          return (
            <div
              key={segmentStep}
              className={`h-1.5 flex-1 rounded-full transition-all duration-500 ${
                isActive ? "bg-[var(--brand-accent)]" : isDone ? "bg-[var(--brand-primary)]" : "bg-black/10"
              }`}
            />
          );
        })}
      </div>
      <h2 className="font-serif text-2xl sm:text-3xl font-medium tracking-tight mt-4 text-[#292522]">
        {t(`steps.${step}.title`)}
      </h2>
    </div>
  );
}
